import {addClass, getCookie, makeElement, removeClass, setCookie} from '../../common/Utils';
import { ncBannerOptions } from '../../interface/ICommonbanner';
import {checkCookie} from './checkCookie';

/**
 * @category Commonbanner
 * @description
 * 플로팅 배너
 * 서브페이지에서만 노출
 * 닫기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */

class FloatingLayer{
    isCookieApply: boolean;    
    bannerEl!: HTMLElement;
    el!: HTMLElement;     
    constructor(_isMain: boolean = false, _isLauncher:boolean = false, _data:ncBannerOptions) {

        this.isCookieApply = checkCookie();
        let thisIsCookieApply = this.isCookieApply && getCookie(_data.floatingCookie);

        if( _isMain || !_data.showFloatingBanner || thisIsCookieApply ){
            return;
        }

        if ( _isLauncher && !_data.floatingLauncherShow) {
            return;
        }

        this.bannerEl = this.template(_data) ;

        document.body.appendChild( this.bannerEl );
        this.addEvents(_data);

        setTimeout(()=> {
            addClass( this.bannerEl , 'is-show');
        }, 1000);

    }


    template(_data: ncBannerOptions){
        this.el = makeElement( `
            <div class="nc-banner" data-type="floating">
                ${_data.floatingLink != ''?`
                <a href="${_data.floatingLink}" ${_data.floatingLinkNewWindow ? 'target=_blank' :''} class="nc-banner-link" style="background-image:url('${_data.floatingBG}')">
                <span class="blind">${_data.floatingTitle}</span>
                </a>
                ` :`
                <span class="nc-banner-link" style="background-image:url('${_data.floatingBG}')">
                <span class="blind">${_data.floatingTitle}</span>
                </span>
                `}
                <button class="nc-banner-close"><span class="blind">그만보기</span></button>
            </div>
        ` );

        return this.el;
    }

    addEvents(_data:ncBannerOptions){
        const dataTypeFloating = document.querySelector(".nc-banner[data-type=floating]") as HTMLElement;
        document.querySelector(".nc-banner[data-type=floating] .nc-banner-close")?.addEventListener('click', e =>{
            if(this.isCookieApply) {
                setCookie('ncBanner'+_data.floatingCookie, "true", 999, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.floatingCookie, "true", 999, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.floatingCookie, "true", 999, '.plaync.com'); // 쿠키 사용
            }
            removeClass(dataTypeFloating, 'is-show');
        });
    }

}
export default FloatingLayer;